<template>
  <div class="row g-3">
    <div class="col-12 col-md-6">
      <select class="form-control" v-model="filter.categoryId">
        <option value="">Категории</option>
        <option
            v-for="cat in categories"
            :key="cat.id"
            :value="cat.id"
        >
          {{ cat.name }}
        </option>
      </select>
    </div>

    <div class="col-12 col-md-6">
      <select class="form-control" v-model="filter.type">
        <option value="">Тип</option>
        <option value="expense">Расход</option>
        <option value="income">Доход</option>
      </select>
    </div>

    <div class="col-12 col-md-6">
      <input class="form-control" v-model="filter.name" placeholder="Название" />
    </div>

    <div class="col-12 col-md-6">
      <div class="row">
        <div class="col-12 col-md-6">
          <input
              ref="amountRefFrom"
              inputmode="decimal"
              class="form-control" v-model="filter.amountFrom" placeholder="Сумма от" />
        </div>
        <div class="col-12 col-md-6">
          <input
              ref="amountRefTo"
              inputmode="decimal"
              class="form-control" v-model="filter.amountTo" placeholder="Сумма до" />
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="row">
        <div class="col-12 col-md-6 d-flex align-items-center gap-2">
          <span>От</span>
          <input class="form-control" v-model="filter.createdAtFrom" type="datetime-local" />
        </div>

        <div class="col-12 col-md-6 d-flex align-items-center gap-2">
          <span>До</span>
          <input class="form-control" v-model="filter.createdAtTo" type="datetime-local" />
        </div>
      </div>
    </div>

    <div class="col-12 d-flex justify-content-start">
      <div class="row">
        <div class="col-12 col-md-6">
          <br>
          <button class="btn btn-primary" @click="emit('applyFilter', filter)">
            Фильтр
          </button>
        </div>
        <div class="col-12 col-md-6">
          <br>
          <button class="btn btn-outline-primary" @click="clearFilter">
            Сбросить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {normalizeAmountInput} from "@/api/helpers";

const props = defineProps({
  categories: {type: Array, required: true},
  initial: {type: Object, required: true},
});


const emit = defineEmits(['applyFilter', 'clearFilter']);

const amountRefFrom = ref(null);
const amountRefTo = ref(null);
onMounted(async () => {
  normalizeAmountInput(amountRefFrom);
  normalizeAmountInput(amountRefTo);
});

const filter = reactive({
  name: props.initial.name ?? '',
  type: props.initial.type ?? '',
  categoryId: props.initial.categoryId ?? '',
  amountFrom: props.initial.amountFrom ?? '',
  amountTo: props.initial.amountTo ?? '',
  createdAtFrom: props.initial.createdAtFrom ?? '',
  createdAtTo: props.initial.createdAtTo ?? '',
});

const clearFilter = () => {
  for (var field in filter) {
    filter[field] = '';
  }
  emit('clearFilter', filter);
}
</script>
